import { hubConnection } from '@linq/signalr-no-jquery';

import * as types from './state/types';
import { signalRMessageHandler } from './MessageHandler';
import {
  signalRStart,
  signalRTrackErrors,
  signalRStop,
  signalRDisconnected,
  signalRReconnected,
} from './Connection';
import { HUB_NAME } from './helpers/constants';

/**
 * Redux Middleware for SignalR
 * https://redux.js.org/advanced/middleware
 *
 * Curried function used in store.js
 *
 */
export function signalRMiddleware(url) {
  let hubProxy = null;
  let connection = null;

  return (store) => {
    const { dispatch, getState } = store;

    return (next) => (action) => {
      if (action.signalR) {
        switch (action.type) {
          case types.SIGNALR_CONNECT:
            // Create a connection if none exists.
            if (!connection) {
              const {
                SecurityState: {
                  userInfo: { userGuid },
                },
              } = getState();

              connection = hubConnection(url, {
                qs: { userGuid },
              });

              hubProxy = connection.createHubProxy(HUB_NAME);

              hubProxy.on('message', function (message) {
                signalRMessageHandler(message, dispatch);
              });

              signalRTrackErrors(connection, dispatch, getState);
              signalRDisconnected(connection, dispatch, getState);
              signalRReconnected(connection, dispatch, getState);
            }

            signalRStart(connection, dispatch, getState);

            break;

          case types.SIGNALR_RECONNECT:
            if (connection) {
              signalRStart(connection, dispatch, getState);
            }

            break;
          case types.SIGNALR_DISCONNECT:
            // This will not be triggered if using the Offline mode in devtools as it currently does not
            // support throttling for sockets. See https://bugs.chromium.org/p/chromium/issues/detail?id=423246
            if (connection) {
              signalRStop(connection, dispatch);
            }
            hubProxy = null;
            connection = null;
            break;
          case types.SIGNALR_INVOKE_MESSAGE:
            if (hubProxy) {
              hubProxy.invoke(action.payload.event, action.payload.payload);
            }
            break;
          default:
          //Do nothing?
        }
      }
      return next(action);
    };
  };
}



// WEBPACK FOOTER //
// ./src/api/SignalR/Middleware.js